import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { TopImageZoomSliderModalButtonBase } from '@/components/modules/pages/top/slider/TopImageZoomSlider/TopImageZoomSliderModal/button/TopImageZoomSliderModalButtonBase';
import { AngleLeftIcon } from '@/components/ui/SvgIcon/Variable/SvgIconComponents';
export const TopImageZoomSliderModalPrevButton = (props) => {
    const { className = '', dataAttributes = {}, disabled = false, onClick = undefined, } = props;
    return (_jsx(TopImageZoomSliderModalButtonBase, { className: clsx(
        // NOTE: ライブラリ内で付与されている class についているスタイルを important で強制上書きしています
        '!top-auto !bottom-[12px] md:!bottom-1/2 !left-auto md:!left-0 !right-[72px] md:!right-auto', 'translate-y-12', className), dataAttributes: dataAttributes, disabled: disabled, icon: AngleLeftIcon, onClick: onClick }));
};
